import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
    to {
        transform: rotate(360deg);
    }
`;

const SpinnerElement = styled.span`
    display: inline-block;
    width: ${props => {
        const sizeMap = { sm: '12px', md: '16px', lg: '24px' };
        return sizeMap[props.size] || sizeMap.sm;
    }};
    height: ${props => {
        const sizeMap = { sm: '12px', md: '16px', lg: '24px' };
        return sizeMap[props.size] || sizeMap.sm;
    }};
    color: ${props => props.color || 'currentColor'};
    
    /* Smooth rotating animation */
    animation: ${spin} 0.8s linear infinite;
    
    /* Create a circular border spinner effect */
    border: 2px solid rgba(255, 255, 255, 0.2);
    border-top: 2px solid currentColor;
    border-right: 2px solid rgba(255, 255, 255, 0.1);
    border-bottom: 2px solid rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    
    /* Ensure it displays inline */
    vertical-align: middle;
    margin-right: 0.4em;
    
    /* Ensure smooth performance */
    will-change: transform;
`;

/**
 * A polished, animated loading spinner component
 * More visually appealing than the default Bootstrap spinner
 * 
 * @param {string} size - 'sm' (12px), 'md' (16px), or 'lg' (24px) - default 'sm'
 * @param {string} color - CSS color value - default 'currentColor'
 */
const LoadingSpinner = ({ size = 'sm', color = 'currentColor' }) => {
    return (
        <SpinnerElement
            size={size}
            color={color}
            role="status"
            aria-label="Loading"
        />
    );
};

export default LoadingSpinner;
